import { FC, memo } from "react";
import { ILearnersProps } from "./learners.props";
import { Container } from "./learners.style";

const Learners: FC<ILearnersProps> = (props: ILearnersProps) => {
  return <Container></Container>;
};

export default memo(Learners);